import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, switchMap, tap, map, catchError, of, startWith } from 'rxjs';
import { DataState } from '../../../model/dataState';
import { NavStateService } from '../../../services/nav-state.service';
import { Verification } from '../../../services/verification';
import { Country } from 'country-state-city';
import { FormControl } from '@angular/forms';
interface PaginationParams {
  page: number;
  size: number;
  country:string,
  companyName:string,
  requestSuccessful:string
}
@Component({
  selector: 'app-verification-history',
  standalone: false,
  templateUrl: './verification-history.html',
  styleUrl: './verification-history.less',
})
export class VerificationHistory {
private verificationService = inject(Verification);
  private navState = inject(NavStateService);
  private router = inject(Router);
  pagination$ = new BehaviorSubject<PaginationParams>({ page: 0, size: 10,country:'',companyName:'',requestSuccessful:''});
  searchTerm: string = '';
  selectedStatus: string = 'All Statuses';
  selectedDateRange: string = 'Last 30 Days';
  verificationList$!: Observable<DataState<any[]>>;
  @Output() moveToDetailsPage = new EventEmitter<any>();
  countryList = Country.getAllCountries();
  currentPage = 0;
  pageSize = 10;
  sortOrder: string = '';
  sortKey: string = '';
  totalPages = 0;
  pages:any[]=[];
  start :number =0;
  end :number = 0;
  totalRecord :number =0;
  stats = {
    pending: 34,
    inReview: 18,
    completed: 195,
    spend: 4850
  };
  filteredCountries$!: Observable<any[]>;
  countrySearchControl = new FormControl('');
  constructor() { }

  ngOnInit(): void {
    this.navState.setCurrentTitle('Verification History');
    this.navState.setShowBackButton(false);
    this.verificationList$ = this.pagination$.pipe(
      switchMap((params) => {
        this.currentPage = params.page;
        this.pageSize = params.size;
        return this.verificationService.getVerificationHistory(params.page, params.size,params.country,params.companyName,params.requestSuccessful).pipe(
          tap((response:any)=>{
            if (response) {
              this.totalRecord = response.total;
              this.totalPages = Math.ceil(response.total / this.pageSize);
              console.log(this.totalPages)
              this.pages = Array.from({ length: this.totalPages }, (_, i) => i)
              console.log(this.pages);
              this.start = this.currentPage * this.pageSize +1;
              console.log(this.start)
              this.end = (this.currentPage + 1) * this.pageSize;
              console.log(this.end)
              if (this.end > this.totalRecord){
                this.end = this.totalRecord;
              }
            }
            
          }),
          map((response: any) => ({
            loading: false,
            error: null,
            data: response.result
          }
        )),
          catchError((error) => of({
            loading: false,
            error: error,
            data: null
          })),
          startWith({
            loading: true,
            error: null,
            data: null
          })
        )
      })
    )
      this.filteredCountries$ = this.countrySearchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
    
    const initialCountry = this.pagination$.value.country || '';
    this.countrySearchControl.setValue(initialCountry, { emitEvent: false });

  }

  startVerificationWorkflow(): void {
    console.log('Routing execution step to Company Details Form component view...');
    this.router.navigate(['/verification/verification-form'],{
      state:{mode:'create'}
    })

   
  }

  // downloadReport(recordId: string): void {
  //   console.log(`Downloading compiled evaluation sheet or raw certificate for execution packet ${recordId}`);
  // }

   private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.countryList.filter(country => 
      country.name.toLowerCase().includes(filterValue)
    );
  }

  onPageChange(newPage: number) {
    if (newPage <1 || newPage >this.totalPages){
      return;
    }
    this.pagination$.next({
      ...this.pagination$.value,
      page: newPage,
      size: this.pageSize,
      
    })
  }


  viewVerificationForm(record:any){
    console.log(record);
    

    // this.moveToDetailsPage.emit(record.id)
    this.moveToDetailsPage.emit(record.verificationRequest.id)
  }

  onCompanyNameChange(name:string){
    this.pagination$.next({
      ...this.pagination$.value,
      companyName:name,
      page:0,
      size:this.pageSize,
    })
  }

  onCountryChange(country:string){
    this.pagination$.next({
      ...this.pagination$.value,
      country:country,
      page:0,
      size:this.pageSize,
    })
  }
  onRequestSuccessfulChange(value:string){
    this.pagination$.next({
      ...this.pagination$.value,
      requestSuccessful:value,
      page:0,
      size:this.pageSize,
    })
  }
}
